"use strict";

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var media_1 = require("./media");

var HomeConfigDTO = function HomeConfigDTO() {
  _classCallCheck(this, HomeConfigDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], HomeConfigDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", media_1.MediaDTO)], HomeConfigDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], HomeConfigDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsArray(), __metadata("design:type", Array)], HomeConfigDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], HomeConfigDTO.prototype, "linkText", void 0);

exports.HomeConfigDTO = HomeConfigDTO;

var HomeConfigUpdateDTO = function HomeConfigUpdateDTO() {
  _classCallCheck(this, HomeConfigUpdateDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], HomeConfigUpdateDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsArray(), __metadata("design:type", Array)], HomeConfigUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], HomeConfigUpdateDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], HomeConfigUpdateDTO.prototype, "linkText", void 0);

exports.HomeConfigUpdateDTO = HomeConfigUpdateDTO;